import { getFocus } from "../../../constants";
import { useThemeContext } from "../../../context";
import { Button } from "../../common";

const Calculator = ({
  className,
  columnFour,
  setState,
  rowData,
  maxLength,
  activeOpenItem,
}) => {
  const { theme } = useThemeContext();

  const onClick = (val, preset) => {
    if (setState && activeOpenItem?.id) {
      let updatedVal;
      if (activeOpenItem.id === "none") return;

      const { fieldName, fieldToFocus } = getFocus(activeOpenItem);
      if (fieldToFocus) {
        fieldToFocus.focus();
      }
      if (rowData.hasOwnProperty(activeOpenItem.id)) {
        const currentVal = rowData[activeOpenItem.id][fieldName] || "";
        updatedVal = currentVal.toString() + val;
      } else {
        updatedVal = val.toString();
      }

      setState((prevState) => {
        return {
          ...prevState,
          [activeOpenItem.id]: {
            ...prevState[activeOpenItem.id],
            [fieldName]: updatedVal,
          },
        };
      });
    }

    if (setState && !activeOpenItem) {
      if (preset) {
        setState((state) => (state ? state + val : val));
      } else {
        maxLength
          ? setState((state) =>
              state?.length < maxLength ? state + val : state
            )
          : setState((state) =>
              state ? eval(state?.toString() + val.toString()) : val
            );
      }
    }
  };

  const removeCharacter = () => {
    if (setState && activeOpenItem?.id) {
      if (activeOpenItem.id === "none") return;
      const { fieldName, fieldToFocus } = getFocus(activeOpenItem);
      if (fieldToFocus) {
        fieldToFocus.focus();
      }

      setState((prevState) => {
        return {
          ...prevState,
          [activeOpenItem.id]: {
            ...prevState[activeOpenItem.id],
            [fieldName]: prevState[activeOpenItem.id]?.[fieldName]
              ?.toString()
              .slice(0, -1),
          },
        };
      });
    }

    if (setState && !activeOpenItem?.id) {
      setState && setState((state) => Number(state.toString().slice(0, -1)));
    }
  };

  return (
    <div className={`calculatorMainBox ${className}`}>
      <div
        className={`calculatorInnerBoxColumn ${
          columnFour ? "calcFourColumn" : "calcThreeColumn"
        }`}
      >
        <Button
          id="calculatorKey"
          className={`width100 fontSize24 cursorPointer`}
          backgroundColor={theme.posRightBg}
          borderColor={theme.posRightBg}
          txtColor={theme.white}
          title="7"
          type="secondary"
          handleClick={() => onClick(7)}
        />
        <Button
          id="calculatorKey"
          className={`width100 fontSize24 cursorPointer`}
          backgroundColor={theme.posRightBg}
          borderColor={theme.posRightBg}
          txtColor={theme.white}
          title="4"
          type="secondary"
          handleClick={() => onClick(4)}
        />
        <Button
          id="calculatorKey"
          className={`width100 fontSize24 cursorPointer`}
          backgroundColor={theme.posRightBg}
          borderColor={theme.posRightBg}
          txtColor={theme.white}
          title="1"
          type="secondary"
          handleClick={() => onClick(1)}
        />
        <Button
          id="calculatorKey"
          className={`width100 fontSize24 cursorPointer`}
          backgroundColor={theme.posRightBg}
          borderColor={theme.posRightBg}
          txtColor={theme.white}
          title="."
          type="secondary"
          handleClick={() => onClick(".")}
        />
      </div>
      <div
        className={`calculatorInnerBoxColumn ${
          columnFour ? "calcFourColumn" : "calcThreeColumn"
        }`}
      >
        <Button
          id="calculatorKey"
          className={`width100 fontSize24 cursorPointer`}
          backgroundColor={theme.posRightBg}
          borderColor={theme.posRightBg}
          txtColor={theme.white}
          title="8"
          type="secondary"
          handleClick={() => onClick(8)}
        />

        <Button
          id="calculatorKey"
          className={`width100 fontSize24 cursorPointer`}
          backgroundColor={theme.posRightBg}
          borderColor={theme.posRightBg}
          txtColor={theme.white}
          title="5"
          type="secondary"
          handleClick={() => onClick(5)}
        />
        <Button
          id="calculatorKey"
          className={`width100 fontSize24 cursorPointer`}
          backgroundColor={theme.posRightBg}
          borderColor={theme.posRightBg}
          txtColor={theme.white}
          title="2"
          type="secondary"
          handleClick={() => onClick(2)}
        />
        <Button
          id="calculatorKey"
          className={`width100 fontSize24 cursorPointer`}
          backgroundColor={theme.posRightBg}
          borderColor={theme.posRightBg}
          txtColor={theme.white}
          title="0"
          type="secondary"
          handleClick={() => onClick(0)}
        />
      </div>
      <div
        className={`calculatorInnerBoxColumn ${
          columnFour ? "calcFourColumn" : "calcThreeColumn"
        }`}
      >
        <Button
          id="calculatorKey"
          className={`width100 fontSize24 cursorPointer`}
          backgroundColor={theme.posRightBg}
          borderColor={theme.posRightBg}
          txtColor={theme.white}
          title="9"
          type="secondary"
          handleClick={() => onClick(9)}
        />
        <Button
          id="calculatorKey"
          className={`width100 fontSize24 cursorPointer`}
          backgroundColor={theme.posRightBg}
          borderColor={theme.posRightBg}
          txtColor={theme.white}
          title="6"
          type="secondary"
          handleClick={() => onClick(6)}
        />
        <Button
          id="calculatorKey"
          className={`width100 fontSize24 cursorPointer`}
          backgroundColor={theme.posRightBg}
          borderColor={theme.posRightBg}
          txtColor={theme.white}
          title="3"
          type="secondary"
          handleClick={() => onClick(3)}
        />
        <Button
          id="calculatorKey"
          className={`width100 fontSize24 cursorPointer buttonStyle`}
          backgroundColor={theme.posRightBg}
          type="iconButton"
          icon_name="newBackSpaceIcon"
          icon_fill={theme.white}
          icon_width={"30"}
          icon_height={"30"}
          icon_viewBox={"0 0 30 30"}
          handleClick={removeCharacter}
        />
      </div>
      {columnFour ? (
        <div
          className={`calculatorInnerBoxColumn ${
            columnFour ? "calcFourColumn" : "calcThreeColumn"
          }`}
        >
          <Button
            id="calculatorKey"
            className={`width100 fontSize24 cursorPointer`}
            backgroundColor={theme.blackBg}
            txtColor={theme.barclaysBlue}
            borderColor={theme.posRightBg}
            title="+5,000"
            type="secondary"
            handleClick={() => onClick(5000, true)}
          />
          <Button
            id="calculatorKey"
            className={`width100 fontSize24 cursorPointer`}
            backgroundColor={theme.blackBg}
            txtColor={theme.barclaysBlue}
            borderColor={theme.posRightBg}
            title="+1,000"
            type="secondary"
            handleClick={() => onClick(1000, true)}
          />
          <Button
            id="calculatorKey"
            className={`width100 fontSize24 cursorPointer`}
            backgroundColor={theme.blackBg}
            txtColor={theme.barclaysBlue}
            borderColor={theme.posRightBg}
            title="+500"
            type="secondary"
            handleClick={() => onClick(500, true)}
          />
          <Button
            id="calculatorKey"
            className={`width100 fontSize24 cursorPointer`}
            backgroundColor={theme.blackBg}
            txtColor={theme.barclaysBlue}
            borderColor={theme.posRightBg}
            title="+100"
            type="secondary"
            handleClick={() => onClick(100, true)}
          />
        </div>
      ) : null}
    </div>
  );
};

export default Calculator;
